export const ActionType = {
  //update action 
  SET_UPDATE_STATUS: 'SET_UPDATE_STATUS',
  //user action type
  SET_USER: 'SET_USER',
  REMOVE_USER: 'REMOVE_USER',
  LOGIN: 'LOGIN',
  AUTO_LOGIN: 'AUTO_LOGIN',
  LOGOUT: 'LOGOUT',

  //company action typs
  SET_COMPANY: 'SET_COMPANY',
  //product function restrict,
  SET_PRODUCT_FUNCTION_RESTRICT: 'SET_PRODUCT_FUNCTION_RESTRICT',

  //redipoint
  // SET_RED_DOTS: 'SET_REDPOINT',
  // CLEAR_RED_DOT: 'CLEAR_RED_DOT',

  // SET_BADGE: 'SET_BADGE',
  // INCR_IM_BADGE: 'INCR_IM_BADGE',

  // SET_IM_STATE: 'SET_IM_STATE',

  // SET_APP_INFO: 'SET_APP_INFO',
};
